import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ReviewsList from './reviews_list/ReviewsList';
import RankingUser from './user_ranking/RankingUser';
import Header from './header/header';
import NoReviews from './no_reviews/NoReviews';
import * as actions from './module';
import translations from './../translations.en.json';
import '@fiverr/i18n/singleton';
import classnames from 'classnames';
import './my-reviews.scss';

class Index extends React.Component {

    constructor() {
        super();
        i18n.add(translations);

        this.toggleCollapsed = this.toggleCollapsed.bind(this);

        this.state = {
            collapsed: true
        };
    }

    toggleCollapsed(e) {
        if ((e.target) && (e.target.nodeName !== 'SELECT')) {
            this.setState({
                collapsed: !this.state.collapsed
            });
        }
    }

    mainClassName() {
        return classnames('reviews-package', {
            'show': !this.state.collapsed
        });
    }

    calcRatingBaseFive() {
        const convertedRating = (this.props.userRating / 20) * 10;
        return Math.round(convertedRating) / 10;
    }

    render() {

        const {
            stars,
            starSummary,
            showLoadMore,
            totalCount,
            type,
            fetchReviews,
            gigId,
            pathFinderConfig
        } = this.props;

        const lastStar = (stars && stars.size) ? stars.get(stars.size-1).get('id') : undefined;

        const headerProps = {
            totalCount,
            ratingFive: this.calcRatingBaseFive(),
            toggleCollapsed: this.toggleCollapsed,
            fetchReviews,
            type,
            lastStar,
            pathFinderConfig
        };

        return (
            <div className={this.mainClassName()}>

                <Header {...headerProps}/>

                <div className="reviews-wrap">
                    <RankingUser starSummary={starSummary}/>
                    <ReviewsList stars={stars}
                        type={type}
                        fetchReviews={fetchReviews}
                        lastStar={lastStar}
                        showLoadMore={showLoadMore}
                        gigId={gigId}
                        pathFinderConfig={pathFinderConfig}/>
                </div>

                <NoReviews stars={stars}
                    type={type}/>

            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    stars: state.get('stars'),
    userRating: state.get('user_rating'),
    starSummary: state.get('star_summary'),
    totalCount: state.get('total_count'),
    showLoadMore: state.get('has_more_pages'),
    type: state.get('type'),
    gigId: state.get('gigId'),
    pathFinderConfig: state.get('pathFinderConfig')
});

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch);

Index.defaultProps = {
    totalCount: 0
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);



// WEBPACK FOOTER //
// ./src/reviews/Reviews.js